

import React from 'react';

const TermsOfService: React.FC = () => {
  return (
    <div style={{ padding: '2rem', maxWidth: '800px', margin: '0 auto', fontSize: '0.95rem' }}>
      <h1>Terms of Service</h1>
      <p>Welcome to Lsnto. By accessing or using our platform, you agree to comply with and be bound by the following terms and conditions.</p>

      <h2>1. Acceptance of Terms</h2>
      <p>By using Lsnto, you agree to be legally bound by these Terms of Service, our Privacy Policy, and any additional terms presented to you during your use of the platform.</p>

      <h2>2. Eligibility</h2>
      <p>To use Lsnto, you must be at least 16 years old or have the permission of a parent or guardian. By registering, you confirm that you meet this requirement.</p>

      <h2>3. Content Ownership</h2>
      <p>You retain full ownership of any content you submit. By submitting content to Lsnto, you grant us a non-exclusive, royalty-free licence to use, display, and promote your content within the platform.</p>

      <h2>4. Appropriate Use</h2>
      <p>You agree not to misuse the platform, including uploading content you don’t have rights to, engaging in fraudulent behaviour, or using abusive or discriminatory language. We reserve the right to suspend or terminate access at our discretion.</p>

      <h2>5. Fair Use and Exclusivity</h2>
      <p>While we encourage exclusive content to benefit fully from Lsnto’s features, this is non-binding. You may remove or distribute your content elsewhere at any time. Abuse of the system may lead to restricted access.</p>

      <h2>6. Changes to Terms</h2>
      <p>We may update these Terms from time to time. Continued use of the platform after changes indicates your acceptance of the new terms.</p>

      <h2>7. Disclaimer</h2>
      <p>We provide Lsnto “as is.” We do not guarantee uninterrupted service or that content will always be available. Use is at your own risk.</p>

      <h2>8. Contact</h2>
      <p>If you have any questions about these Terms, please contact us at info@lsnto.com.</p>
    </div>
  );
};

export default TermsOfService;